import { CurrentUser } from "../../../modules/seguranca/current-user.model";
import { MessageService } from "./../../message/message.service";
import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../common/shared.service";
import { Router, ActivatedRoute } from "@angular/router";
import { Usuario } from "../../../modules/seguranca/usuario/usuario";
import { UsuarioService } from "../../../modules/seguranca/usuario/usuario.service";
import { ConfiguracaoLoginService } from "../../../modules/basico/configuracao-login/configuracao-login.service";
import { ConfiguracaoLogin } from "../../../modules/basico/configuracao-login/configuracao-login";
import { Entidade } from "../../../modules/basico/entidade/entidade";
import { EntidadeService } from "../../../modules/basico/entidade/entidade.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  usuario = new Usuario();
  shared: SharedService;
  message: string;
  configuracao: ConfiguracaoLogin;

  constructor(
    private usuarioService: UsuarioService,
    private router: Router,
    private route: ActivatedRoute,
    private notificador: MessageService,
    private entidadeService: EntidadeService,
    private configuracaoService: ConfiguracaoLoginService
  ) {
    this.shared = SharedService.getInstance();
  }

  ngOnInit() {
    let id = this.route.snapshot.params.id;
    if (id) {
      this.configuracaoService
        .getConfiguracao(id)
        .subscribe((data) => (this.configuracao = data));
    }
  }

  login() {
    this.message = "";
    this.usuarioService
      .login({ cpf: this.usuario.cpf, senha: this.usuario.password })
      .subscribe(
        (userAuthentication: CurrentUser) => {
          this.shared.logando(userAuthentication);
          this.usuarioService.checarCpf(this.usuario.cpf).subscribe((rs) => {
            this.usuarioService.logar().subscribe();
            console.log(rs);
            this.shared.adm = rs;
            this.router.navigate(["/"]);
          });
        },
        (err) => {
          this.shared.token = null;
          this.shared.usuario = null;
          // console.log(err);
          this.notificador.messageErro("CPF ou Senha Inválido!");
        }
      );
  }

  getImage(entidade: Entidade): any {
    return this.entidadeService.getImagem(entidade).subscribe((d) => d);
  }
}
